import React, { useMemo } from 'react';
import { Select, Typography } from 'antd';

const { Text } = Typography;

export interface EpcApprovedRevisionPickerProps {
  revisions: Array<Record<string, unknown>>;
  value?: string;
  onChange: (revisionId: string | undefined) => void;
  /** When true, only Approved revisions are selectable (default). */
  approvedOnly?: boolean;
  label?: string;
  disabled?: boolean;
}

/**
 * Exact Approved revision picker for certify-estimate-basis — never current_revision_id.
 */
export const EpcApprovedRevisionPicker: React.FC<EpcApprovedRevisionPickerProps> = ({
  revisions,
  value,
  onChange,
  approvedOnly = true,
  label = 'Approved estimate revision',
  disabled,
}) => {
  const options = useMemo(() => {
    const rows = revisions || [];
    const filtered = approvedOnly
      ? rows.filter((r) => String(r.status || '').toLowerCase() === 'approved')
      : rows;
    return filtered.map((r) => ({
      value: String(r.id),
      label: `${r.revision_label || r.revisionLabel || 'Rev'} · ${r.status}${
        r.approved_at || r.approvedAt
          ? ` · ${String(r.approved_at || r.approvedAt).slice(0, 10)}`
          : ''
      }`,
    }));
  }, [revisions, approvedOnly]);

  return (
    <div>
      <Text type="secondary" style={{ display: 'block', marginBottom: 6 }}>
        {label}
      </Text>
      <Select
        style={{ width: '100%' }}
        placeholder={options.length ? 'Select Approved revision' : 'No Approved revisions'}
        options={options}
        value={value}
        onChange={(v) => onChange(v)}
        disabled={disabled || options.length === 0}
        allowClear
        showSearch
        optionFilterProp="label"
      />
      {options.length === 0 ? (
        <Text type="danger" style={{ display: 'block', marginTop: 6, fontSize: 12 }}>
          Approve an EST3 revision first — certify never uses the working draft.
        </Text>
      ) : null}
    </div>
  );
};

export default EpcApprovedRevisionPicker;
